import React, { FC } from 'react';
import { useIntl } from 'react-intl';
import HeroSection from './HeroSection';
import FreeCrypto from './FreeCrypto';
import { DataType } from '../../pages';
import Rewards from './Rewards/Rewards';
import FAQ from './FAQ';
import SpendRewards from './SpendRewards';
import Advertise from './Advertise';
import ReadytoGetStarted from './ReadytoGetStarted';
import Navbar from './NavbarHome';
import Footer from './Footer';

const View: FC<{ data: DataType }> = () => {
  const { locale } = useIntl();

  return (
    <>
      <Navbar locale={locale} />

      <HeroSection />
      <FreeCrypto />
      <Rewards />
      <SpendRewards />
      <FAQ />
      <Advertise />
      <ReadytoGetStarted />

      <Footer />
    </>
  );
};

export default View;
